import { render } from "./dialogUsuarioAlta.vue?vue&type=template&id=97f743a4&scoped=true"
import script from "./dialogUsuarioAlta.vue?vue&type=script&lang=js"
export * from "./dialogUsuarioAlta.vue?vue&type=script&lang=js"

import "./dialogUsuarioAlta.vue?vue&type=style&index=0&id=97f743a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97f743a4"]])

export default __exports__